module.exports = __webpack_public_path__ + "img/check.26df3e1f.svg";